import angular from 'angular';
import PartNumberFormatterService from './part-number-formatter.service';
import BreadcrumbParserService from './breadcrumb-parser.service';
import IconFormatterService from './icon-formatter.service';
import CurrencyFormatterService from './currency-formatter.service';
import NumberFormatterService from './number-formatter.service';
import PartCountFormatterService from './part-count-formatter.service';

export default angular.module('FormatterModule', [])
    .factory('PartNumberFormatterService', PartNumberFormatterService)
    .factory('BreadcrumbParserService', BreadcrumbParserService)
    .factory('IconFormatterService', IconFormatterService)
    .factory('CurrencyFormatterService', CurrencyFormatterService)
    .factory('NumberFormatterService', NumberFormatterService)
    .factory('PartCountFormatterService', PartCountFormatterService)

    .name; // must come last
